import React from 'react'
import PropTypes from 'prop-types'
import { Typography, Box, Paper } from '@material-ui/core'
import numeral from 'numeral'

//Components
import AdvanceCustomedTable from 'StandardComponents/AdvanceCustomedTable/AdvanceCustomedTable'
import CustomedTableFooter from 'StandardComponents/CustomedTableFooter/CustomedTableFooter'
import SideNav from 'components/sidenav/Sidenav'

// Services
import NonPOItemsServices from 'Services/Api/NonPOItem/nonPOItem'

// Styles
import classes from './MyLiquidation.module.scss'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
}

const headers = [
  { label: 'CRF#', width: '100px' },
  { label: 'Date Released', width: '100px' },
  { label: 'Deadline for Liquidation', width: '100px' },
  { label: 'Amount', width: '100px' },
  { label: 'Project', width: '150px' },
  { label: 'Date Liquidated', width: '100px' },
  { label: 'Status', width: '100px' },
]

export default function MyLiquidations(props) {
  const id = props.match.params.id
  const [value, setValue] = React.useState(0)
  const [data, setData] = React.useState([])
  const [params, setParams] = React.useState({
    order: true,
    orderBy: '_id',
    sort: 1,
    search: 'Cash Advance',
    status: 'Check Released',
    id: id
  })
  const [refresh, setRefresh] = React.useState(false)
  const [loading, setLoading] = React.useState(true)

  // pagination
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(5)

  React.useEffect(() => {
    NonPOItemsServices.getManyCheckRequestForm(params).then(res => {
      const fetchedData = res.data.data
      if (fetchedData.length) {
        setLoading(false)
      } else {
        setLoading(true)
      }
      setData(fetchedData)
    })
  }, [refresh])


  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const searchText = (e) => {
    let _params = {
      sort: 1,
      ...params
    }
    _params.search = e.target.value ? e.target.value : toString(e.target.value)
    NonPOItemsServices.getManyCheckRequestForm(_params).then(function (response) {
      setData(response.data.data)
      if (response.data.data.length) {
        setLoading(false)
      } else {
        setLoading(true)
      }
    })
  }

  const handleOnTotal = () => {
    let total = 0
    let totalNetPrice = 0
    let totalAmount = 0
    data.map(item => {
      totalNetPrice += item.totalNetPrice
      if (item.requestType === 'Cash Advance') totalAmount += item.amount
    })
    total = totalNetPrice + totalAmount
    return numeral(total).format('0,0.00')
  }

  return (
    <div className={classes.main_root}>
      <div id='sidePanel' className={classes.side_panel}>
        <SideNav
        />
      </div>
      <div className={classes.root}>
        <div className={classes['header-container']}>
          <Typography className={classes.header}>My Liquidations</Typography>
        </div>
        <AdvanceCustomedTable
          headers={headers}
          type={'liquidation'}
          data={data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
          loading={loading}
        />
        <div className={classes.footer}>
          <CustomedTableFooter
            placeholder={'Search by CRF#...'}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleChangePage={handleChangePage}
            rows={data}
            rowsPerPage={rowsPerPage}
            page={page}
            searchText={searchText}
          />
        </div>
        <Paper className={classes.footer_information_container}>
          <Typography className={classes.label_total}>Total Amount:</Typography>
          <Typography className={classes.value_total}>₱ {handleOnTotal()}</Typography>
        </Paper>
      </div>
    </div>

  )
}
